module.exports = __webpack_public_path__ + "static/media/chevron-square-left.2b94e917.svg";